import { notify } from "../../api/photoshop";

const forbiddenWords = [
	"porn",
	"pornography",
	"porno",
	"erotic",
	"erotica",
	"naked",
	"nude",
	"nudity",
	"nsfw",
	"explicit",
	"sexual",
	"sex",
	"sexually explicit",
	"adult content",
	"xxx",
	"penis",
	"vagina",
	"vulva",
	"clitoris",
	"testicle",
	"testicles",
	"scrotum",
	"anus",
	"anal",
	"genital",
	"genitals",
	"genitalia",
] as const;

export function checkPromptSafety(prompt: string):
	| {
			detected: true;
			onFailed: () => Promise<void>;
	  }
	| { detected: false } {
	const regexPattern = new RegExp(`\\b(${forbiddenWords.join("|")})\\b`, "i");

	const match = prompt.match(regexPattern);

	if (match) {
		return {
			detected: true,
			onFailed: async () => {
				await notify(`Inappropriate Content Detected.
				Your prompt contains terms that may be considered explicit or adult content. Please remove or modify these keywords and try again.`);
			},
		};
	}

	return { detected: false };
}
